module.exports = __webpack_public_path__ + "static/media/login-v2.0c84fbce.png";